import { useContext, useEffect, useState } from "react";
import { AdminService } from "../../../Services/Admin.service";
import { Table, Dropdown, DropdownButton, Pagination } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import AdminListStatus from "../../../Components/AdministrativeSettings/AdminListStatus";
import AdminListRole from "../../../Components/AdministrativeSettings/AdminListRole";
import navdots from "../../../Assets/images/navdots.svg";
import Toaster from "../../../Components/Toaster";
import { Link } from "react-router-dom";
import AdminRoleDropdown from "../../../Components/AdministrativeSettings/AdminRoleDropdown";
import AdminStatusDropdown from "../../../Components/AdministrativeSettings/AdminStatusDropdown";

import SearchInput from "../../../Components/AdministrativeSettings/SearchInput";
import AdminTableRow from "../../../Components/AdministrativeSettings/AdminTableRow";
import TablePagination from "../../../Components/AdministrativeSettings/TablePagination";
import NoListDataAvailable from "../../../Components/NoListDataAvailable";
import LoadingComponent from "../../../Components/LoadingComponent";
import TokenService from "../../../Services/Token.service";
import { useMediaQuery } from "react-responsive";
import AdminListActionsDropdown from "../../../Components/AdministrativeSettings/AdminListActionsDropdown";
import { GlobalInfo } from "../../../Contexts/GlobalContext";
import { FilterInfo } from "../../../Contexts/FilterContext";
import Loader from "../../../Components/Loader";
function  AdminListTable(props) {

  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('');

  const [totalUsers, setTotalUsers] = useState(0);
  const [adminList, setAdminList] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { adminManagementState, setAdminManagementState } = useContext(FilterInfo);
  // const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });
  const [pagination, setPagination] = useState(adminManagementState);
  // useEffect(()=>{
  //   setPagination(adminManagementState);
  // },[])

  const [searchName, setSearchName] = useState("");
  const [isSearchInputVisible, setSearchInputVisible] = useState(false);
  const [searchEmail, setSearchEmail] = useState("");
  const [isSearchEmailVisible, setSearchEmailVisible] = useState(false);
  const [searchPhone, setSearchPhone] = useState("");
  const [isSearchPhoneVisible, setSearchPhoneVisible] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [isSearchIdVisible, setSearchIdVisible] = useState(false);

  const { isClearFilter } = props;
  const { onFilterCountChange } = props;
  useEffect(() => {
    if (isClearFilter) {
      setSelectedStatuses([]);
      setSelectedRoles([]);
      setSearchName("");
      setSearchInputVisible(false);
      setSearchEmail("");
      setSearchEmailVisible(false);
      setSearchPhone("");
      setSearchPhoneVisible(false);
      setSearchId("");
      setSearchIdVisible(false);
      onFilterCountChange(0);
    }
  }, [isClearFilter]);

  // Calculate and update the filter count
  useEffect(() => {
    const count = [
      selectedStatuses.length > 0 ? 1 : 0,
      selectedRoles.length > 0 ? 1 : 0,
      searchName ? 1 : 0,
      searchEmail ? 1 : 0,
      searchPhone ? 1 : 0,
    ].reduce((sum, val) => sum + val, 0);

    onFilterCountChange(count);
  }, [selectedStatuses, selectedRoles, searchName, searchEmail, searchPhone]);

  useEffect(() => {
    fetchRoles();
    fetchStatuses();
  }, []);

  useEffect(() => {
    fetchAdminList();
  }, [pagination, selectedStatuses, selectedRoles, searchName, searchEmail, searchPhone, searchId]);

  const userId = TokenService.getUserId();
  function fetchAdminList() {


    const filters = {
      roles: selectedRoles,
      name: searchName,
      id: searchId,
      email: searchEmail,
      phone_number: searchPhone,
      status: selectedStatuses,
    };

    const params = {
      limit: pagination.limit,
      offset: pagination.offset,
      user_id: userId,
      filters: [filters],
    };

    AdminService.getAdminList(params)
      .then((response) => {
        setAdminList(response.data.list);
        setTotalUsers(response.data.total_users);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch admin list", error);
        setToastMessage(error.message);
        setShowToast(true);
        setToastVariant('error');
        setLoading(false);
      });
  }

  function fetchRoles() {
    AdminService.getAdminListRoleTypes()
      .then((roleTypes) => {
        setRoles(roleTypes);
      })
      .catch((error) => {
        console.error("Failed to fetch role types", error);
      });
  }

  function fetchStatuses() {
    AdminService.getAdminListStatusTypes()
      .then((statusTypes) => {
        setStatuses(statusTypes);

      })
      .catch((error) => {
        console.error("Failed to fetch status types", error);
      });
  }

  const handleStatusChange = (status) => {
    if (selectedStatuses.includes(status)) {
      setSelectedStatuses(selectedStatuses.filter((s) => s !== status));
    } else {


      setSelectedStatuses([...selectedStatuses, status]);
    }
    setPagination({ ...pagination, page: 1, offset: 0 });
    setAdminManagementState({ ...pagination, page: 1, offset: 0 });
  };

  const handleRolesChange = (role) => {
    if (selectedRoles.includes(role)) {
      setSelectedRoles(selectedRoles.filter((r) => r !== role));
    } else {
      setSelectedRoles([...selectedRoles, role]);
    }
    setPagination({ ...pagination, page: 1, offset: 0 });
    setAdminManagementState({ ...pagination, page: 1, offset: 0 });
  };

  const handleChangeStatus = async (admin, status) => {
    setLoading(true);
    const newStatus = admin.active ? 0 : 1; // Determine the new status
    try {
      const response = await AdminService.changeUserStatus(admin.id, newStatus); // Pass the user ID and new status

      if (response.success == true) {
        setToastMessage(response.message);
        setShowToast(true);
        setToastVariant('success');
        fetchAdminList();
        setLoading(false);
      }
      else {
        setToastMessage(response.message);
        setShowToast(true);
        setToastVariant('error');
        setLoading(false);

      }
    } catch (error) {
      console.error("Failed to change user status:", error);
      setLoading(false);

    }
  };

  const handleDeleteUser = async (userId) => {
    try {

      const response = await AdminService.deleteAdminUser(userId);

      if (response.success == true) {
        setToastMessage(response.message);
        setShowToast(true);
        setToastVariant('success');
        console.log("User deleted successfully:", response);
        fetchAdminList();
      }
      else {
        setToastMessage(response.message);
        setShowToast(true);
        setToastVariant('error');
      }
    } catch (error) {
      console.error("Failed to delete user:", error);
    }
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {

    if (newRowsPerPage === 'Show All') {
      setRowsPerPage(totalUsers);
      setPagination({ limit: totalUsers, offset: 0, page: 1 });
      setAdminManagementState({ limit: totalUsers, offset: 0, page: 1 });
    } else {
      setRowsPerPage(Number(newRowsPerPage));
      setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
      setAdminManagementState({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
    }
  };

  const totalFiltered = adminList.length;  //ex 10 
  const totalPages = Math.ceil(totalUsers / rowsPerPage); // 10 / 2rpp  then  5 pages

  const handleNextPage = () => {
    setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    setAdminManagementState({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
  };

  const handlePreviousPage = () => {
    setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    setAdminManagementState({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
  };
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div> 
        <Loader loading={loading}/>
         {isMobile ? (
           <div className="admin-card-list mt-3">
            {adminList.length > 0 ? (
              <div  className="row"> 
              {
                adminList.map((admin, index) => (
              <div className="col-sm-12 col-md-6 mb-3" key={admin.id}>
              <AdminTableRow
                key={index}
                admin={admin}
                handleChangeStatus={handleChangeStatus}
                handleDeleteUser={handleDeleteUser}
              />
              </div>
            ))}</div>) : (<NoListDataAvailable type="admin" />)}
         </div>
         ):(<>
         
      <div className="el-table-container el-board-table">
        <Table hover >
          <thead>
            <tr>
              <th>
                <SearchInput
                  label="Name"
                  value={searchName}
                  setValue={setSearchName}
                  isVisible={isSearchInputVisible}
                  setVisible={setSearchInputVisible}
                />
              </th>
              <th>
                <AdminRoleDropdown
                  roles={roles}
                  selectedRoles={selectedRoles}
                  handleRolesChange={handleRolesChange}
                  setSelectedRoles={setSelectedRoles}
                />
              </th>
              {/* <th>
                <SearchInput
                  label="ID"
                  value={searchId}
                  setValue={setSearchId}
                  isVisible={isSearchIdVisible}
                  setVisible={setSearchIdVisible}
                /> 
              </th> */}
              <th>
                <SearchInput
                  label="Email Address"
                  value={searchEmail}
                  setValue={setSearchEmail}
                  isVisible={isSearchEmailVisible}
                  setVisible={setSearchEmailVisible}
                />
              </th>
              <th>
                <SearchInput
                  label="Phone Number"
                  value={searchPhone}
                  setValue={setSearchPhone}
                  isVisible={isSearchPhoneVisible}
                  setVisible={setSearchPhoneVisible}
                />
              </th>
              <th>
                <AdminStatusDropdown
                  statuses={statuses}
                  selectedStatuses={selectedStatuses}
                  handleStatusChange={handleStatusChange}
                  setSelectedStatuses={setSelectedStatuses}
                  label = "Status"
                />
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {adminList.length > 0 ? (adminList.map((admin, index) => (
              <AdminTableRow
                key={index}
                admin={admin}
                handleChangeStatus={handleChangeStatus}
                handleDeleteUser={handleDeleteUser}
              />
            ))) : (<NoListDataAvailable type="admin" />)}
          </tbody>
        </Table>
      </div>
         
         </>)}
      <TablePagination
        rowsPerPage={rowsPerPage}
        handleRowsPerPageChange={handleRowsPerPageChange}
        pagination={pagination}
        totalPages={totalPages}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
        totalUsers={totalUsers}
      />
      <Toaster
        show={showToast}
        message={toastMessage}
        variant={toastVariant}
        onClose={() => setShowToast(false)}
      />
    </div>
  );
}
export default AdminListTable;
